import { render, staticRenderFns } from "./offerPositionComponent.vue?vue&type=template&id=b8c31cf8&scoped=true"
import script from "./offerPositionComponent.vue?vue&type=script&lang=js"
export * from "./offerPositionComponent.vue?vue&type=script&lang=js"
import style0 from "./offerPositionComponent.vue?vue&type=style&index=0&id=b8c31cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c31cf8",
  null
  
)

export default component.exports